import moment from "moment";

const reportTableRows = [
  // {
  //     report_name: "Employee report",
  //     report: 'employee',

  // },
  {
    report_name: "Session Details Report",
    report: "session",
  },
  {
    report_name: "Program Report",
    report: "program",
  },
  {
    report_name: "Daily Program Schedule",
    report: "daily-program",
  },
  {
    report_name: "Attendance Report",
    report: "custom/attendance-report",
  },
  {
    report_name: "Attendance Report",
    report: "attendance-report",
  },
  {
    report_name: "Classroom Allocation Report",
    report: "classroom",
  },
  {
    report_name: "Resource Person Allocation Report",
    report: "resource-person",
  },
  {
    report_name: "Assessment Report",
    report: "assesment",
  },
  {
    report_name: "Module Plan Amendment Request Report",
    report: "module-plan-amendment",
  },
  {
    report_name: "Module Plan Approval/Recommendation Pending Report",
    report: "module-plan",
  },
  {
    report_name: "Module Allocation for Consultants Report",
    report: "module-allocation-consultant",
  },
  {
    report_name: "Module Allocation for Program Assistant Report",
    report: "module-allocation-program-assistant",
  },
  {
    report_name: "Module Allocation(Yearly) - PA Report",
    report: "module-allocation-yearly",
  },
  {
    report_name: "Student Enrolment & Attendance Details",
    report: "custom/student-enrollment-report",
  },
  {
    report_name: "Student Enrolment & Attendance Summary Report",
    report: "student-enrolment-&-summary-report",
  },
  {
    report_name: "Library Access Report",
    report: "custom/library-access-report",
  },
  {
    report_name: "Resource Persons by Subject Areas Report", //name changes to Resource Persons by Subject Areas Report after development
    report: "resource-person-report",
  },
  {
    report_name: "Internal Consultant Lecture Involvement Report",
    report: "internal-consultant-lecture-involvement-report",
    params: {
      year: moment().year(),
      month: moment().month() + 1
    }
  },
  {
    report_name: "Student Credit Details Report",
    report: "student-credit-details-report",
  },
  {
    report_name: "Evaluation Summary Report",
    report: "evaluation-summary-report",
  },
  {
    report_name: "Module Coordinator Evaluation Report",
    report: "module-coordinator-evaluation-report",
  },
  {
    report_name: "Module Wise Recourse Persons Comments’ Report",
    report: "module-wise-rp-comments-report",
  },
  {
    report: "module-wise-pc-comments-report",
    report_name: "Program Coordination Comments’ Report",
  },
  {
    report: "facility-comments-report",
    report_name: "Facility Comments Report",
  },
  {
    report: "resource-person-evaluation-report",
    report_name: "Resource Person Evaluation Report",
  },
  {
    report: "slida-facility-evaluation-report",
    report_name: "SLIDA Facility Evaluation Report",
  },
  {
    report: "custom/module-wise-review-report",
    report_name: "Module Wise Review Report",
  }
  // {
  //   report_name: "Pending Module Plan Report",
  //   report: "pending-module-plan",
  // },
  // {
  //   report_name: "Pending Amendment Request Report",
  //   report: "pending-amendment-request",
  // },
  // {
  //   report_name: "Session Report V2",
  //   report: "custom/session-report-v2",
  // }
];

export default reportTableRows;
